'use client';
import React from 'react';
import { Card, CardTitle } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import { useSelector } from 'react-redux';
import { storeSelectors } from '@/store';
import { VehicleDetails } from '@/components';

const DetailsOverview = () => {
  const { translate } = useTranslations();
  const activeRecord = useSelector(storeSelectors.selectActiveRecord);

  return (
    <Card>
      <Card.Body>
        <CardTitle title={translate('Szczegóły przejazdu')} />
        {activeRecord != null && <VehicleDetails details={activeRecord} />}
      </Card.Body>
    </Card>
  );
};

export default DetailsOverview;
